export default __webpack_public_path__ + "static/Денежный поток 303+404_2-45e0199f2ffa933d1f30bcb4d18796e2.jpg";